import authService from "./auth.service";

let started = false;
let inactivityTimer = null;
const AUTO_LOGOUT_TIME = 15 * 60 * 1000;

const resetTimer = () => {
  if (inactivityTimer) clearTimeout(inactivityTimer);

  inactivityTimer = setTimeout(() => {
    authService.logout();
  }, AUTO_LOGOUT_TIME);
};

const startIdleTracking = () => {
  if (started) return;
  started = true;

  const events = [
    "mousemove",
    "mousedown",
    "mouseup",
    "keydown",
    "scroll",
    "touchstart",
    "touchmove",
    "pointermove",
  ];
  events.forEach((event) => window.addEventListener(event, () => resetTimer()));

  resetTimer("init");
};

const stopIdleTracking = () => {
  started = false;
  if (inactivityTimer) clearTimeout(inactivityTimer);
};

export default {
  startIdleTracking,
  stopIdleTracking,
};
